import { useEffect } from 'react';
import { adminService } from '../services/adminService';

const HEARTBEAT_INTERVAL = 5 * 60 * 1000; // 5 minutes

export const useSessionHeartbeat = (isAuthenticated: boolean) => {
  useEffect(() => {
    if (!isAuthenticated) return;

    const sendHeartbeat = () => {
      const sessionId = localStorage.getItem('sessionId');
      if (sessionId) {
        adminService.sendHeartbeat(parseInt(sessionId));
      }
    };

    // Send immediately on mount
    sendHeartbeat();

    const interval = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL);
    return () => clearInterval(interval);
  }, [isAuthenticated]);
};
